// images
import lf from "../../images/lf.png"
import lfp2 from "../../images/lfp2.png"
import React from 'react';
import tr28 from "../../triangles/tr28.png"
import tr29 from "../../triangles/tr29.png"
import tr30 from "../../triangles/tr30.png"
import {Environment} from '../../constants/environment.ts';
// Imports 
import "./SignUp.scss"
import { Stack , Typography , Button } from "@mui/material";
import { Second } from "../Demo/Demo";
import CheckIcon from '@mui/icons-material/Check';
import { useEffect,useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BeatLoader } from 'react-spinners';
import Modal from 'react-modal';
Modal.setAppElement('#root'); 
function SignUp() {
  const [isOpen, setIsOpen] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpData, setOtpData] = useState({});
  const [fileData,setFileData]= useState({});
  const [loading, setLoading] = useState(false);
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: '1px solid #ccc',
      borderRadius: '10px',
      padding: '20px',
      width: '300px',
    } 
  };
  const getBase64 = file => {
    return new Promise(resolve => { 
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader(); 
      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => { 
        baseURL = reader.result; 
        resolve(baseURL);
      }; 
    });
  };
  const handleFileInputChange = e => { 
   

    let file = e.target.files[0];

    getBase64(file)
      .then(result => {
        file["base64"] = result;  
        setFileData({
          base64: result,
          file
        });
      })
      .catch(err => {
        console.log(err);
      });

    setFileData({
      file: e.target.files[0]
    });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
     // Create a FormData object from the form
     const formData = new FormData(event.target);
   let model={};
   if(!fileData || !fileData.base64 || !fileData.base64.length){
    
    const errorMessage=localStorage.getItem("lang") === "en"?
          "Please upload VAT cerificate file"
          :
          "الرجاء إرفاق شهادة ضريبة القيمة المضافة";
    toast.error(errorMessage);
    return;
   }
    if(document.getElementById('company') && document.getElementById('company').value && document.getElementById('company').value.length){
      model.accountName=document.getElementById('company').value;
      model.email=document.getElementById('email').value;
      model.mobile=document.getElementById('mobile').value;
      model.password=document.getElementById('password').value;
      model.activeCommercialRegister=formData.get('activeCommercialRegister')==='Yes';
      model.activeTaxNumber=formData.get('activeTaxNumber')==='Yes';
      model.vatFile=fileData.base64;
     
    }else{
      model.accountName=document.getElementById('company1').value;
      model.email=document.getElementById('email1').value;
      model.mobile=document.getElementById('mobile1').value;
      model.password=document.getElementById('password1').value;
      model.activeCommercialRegister=formData.get('activeCommercialRegister1')==='Yes';
      model.activeTaxNumber=formData.get('activeTaxNumber1')==='Yes';
      model.vatFile=fileData.base64;
    }
    if(!model.activeCommercialRegister || !model.activeTaxNumber){
      const errorMessage=localStorage.getItem("lang") === "en"?
          "Please contact with customer setvice on +966550379547"
          :
          "الرجاء التواصل مع خدمة العملاء 00966550379547";
    toast.error(errorMessage);
      
      return;
    }
    setLoading(true);
    
    await fetch(`${Environment.financeApi}/api/Auth/register`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
            'Accept-Language': localStorage.getItem("lang"),
        },
        body: JSON.stringify(model),
    }).then((res)=>res.json().then((response)=>{
      setLoading(false);
      console.log('register',response);
      if (response.hasError) {
        toast.error(response.message);
      }else{
        setOtpData(response.data);
        toast.success(response.message);
        setIsOpen(true); // Open the OTP dialog
      }
    })).catch(e=>{
      setLoading(false);
      console.log(e);
      const errorMessage=localStorage.getItem("lang") === "en"?
      "An error has been occurred, please try again or contact our support"
      :
      "حدثت مشكلة، الرجاء المحاولة لاحقاً أو التواصل مع الدعم";
      toast.error(errorMessage);
    });
    
    
    
  };
  const handleOtpSubmit = async (event) => {
    event.preventDefault();
    const model={ 
      userId: otpData.userId,
      accountId: otpData.accountId
    }
    setLoading(true);
    await fetch(`${Environment.financeApi}/api/Trial/Validate/${otp}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
            'Accept-Language': localStorage.getItem("lang"),
        },
        body: JSON.stringify(model),
      }).then((res)=>res.json().then((response)=>{
        setLoading(false);
        console.log('Validate',response);
        if (response.hasError) {
          toast.error(response.message);
        }else{
          toast.success(response.message,{autoClose: 2000});
          setIsOpen(false); // Close the OTP dialog
          const infoMessage=localStorage.getItem("lang") === "en"?
          "Your login information has been sent to your phone number and email"
          :
          "لقد تم ارسال معلومات تسجيل الدخول إلى رقم هاتفك وبريدك الالكتروني";
          toast.info(infoMessage,{autoClose: 10000});
        } 
    })).catch(e=>{
      setLoading(false);
      console.log(e);
      toast.error('Error');
    });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  } , [])
if (localStorage.getItem("lang") === "en") {
  return (  
      <div className="Login"> 
        <div className="dFirst login sign">
        
          <img src={tr28} alt="" className="tr28" />
          <img src={tr29} alt="" className="tr29" />
          <img src={tr30} alt="" className="tr30" />
          
          <Stack direction={{xs : "column" , md : "row"}} alignItems={{xs : "center" , md : "start"}} spacing={30} justifyContent="center">
            <Stack width="fit-content" py={{xs : 16 , sm : 32}} px={{xs : 15 , sm : 30}} border="1px solid" borderColor="text" alignItems="center" borderRadius="50px">
              <div><img src={lf} alt="" /></div>
              <Typography sx={{
                fontWeight : "400",
                fontSize : "20px",
                mb :10,
                mt : 10
              }}>
              Register
              </Typography>
              <Stack direction="row" spacing={{xs : 2 , sm : 8}} mb={15} > 
                <Stack direction="row" alignItems="center" spacing={2}>
                  <CheckIcon color="secondary" />
                  <Typography sx={{fontSize : {xs : "14px" , sm : "16px"} , fontWeight : "400"}} >
                    Free trial 
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <CheckIcon color="secondary" />
                  <Typography sx={{fontSize : {xs : "14px" , sm : "16px"} , fontWeight : "400"}} >
                    No credit cards 
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <CheckIcon color="secondary" />
                  <Typography sx={{fontSize : {xs : "14px" , sm : "16px"} , fontWeight : "400"}} >
                    Start now 
                  </Typography>
                </Stack>
              </Stack>
              <form onSubmit={handleSubmit}>
                <Stack spacing={12} mb={10} alignItems="center">
                <input id="company1" type="text" placeholder="Company Name" required />
                <input id="email1" type="email" placeholder="Email" required />
                <input id="mobile1" type="number" placeholder="Phone Number" required />
                <input id="password1" type="password" placeholder="Password" required />
                {
                fileData?.file?.name ?
                (
                   <label id="lab" htmlFor="vat1">{fileData?.file?.name}</label>
                ):
                (
                  <label id="lab" htmlFor="vat1">Attach VAT Number Certificate File</label>
                )
              } 
                <input type="file" placeholder="Attach VAT Number Certificate" id="vat1" name="vat1" accept=".pdf,.png,.jpg,.jpeg"  onChange={handleFileInputChange} />
                <Typography sx={{
           fontWeight : "400",
           fontSize : {xs : "16px" , sm : "20px"},
           lineHeight : {xs : "10px" , sm : "40px"},
           textAlign : {xs : "center" , sm : "left"} 
          }}>
              Do you have an effective commercial register? 
            <label className="yes" style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeCommercialRegister"
                value="Yes"
                required 
                style={{margin:"17px 0 17px 25px"}} 

              />
              Yes
            </label>
            <label className="yes" style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeCommercialRegister"
                value="No"
                required 
                style={{margin:"17px 0 17px 35px"}} 
                
              />
              No
            </label> 
            
          </Typography>

          <Typography sx={{
           fontWeight : "400",
           fontSize : {xs : "16px" , sm : "20px"},
           lineHeight : {xs : "10px" , sm : "40px"},
           textAlign : {xs : "center" , sm : "left"} 
          }}>
              Do you have an effective tax number? 
            <label className="yes" style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeTaxNumber1"
                value="Yes"
                required
                style={{margin:"17px 0 17px 25px"}} 

              />
              Yes
            </label>
            <label className="yes" style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeTaxNumber1"
                value="No"
                required 
                style={{margin:"17px 0 17px 35px"}} 
                
              />
              No
            </label> 
            
          </Typography>
                </Stack>
                
                <Stack alignItems="center">
                  <Button type="submit" variant="contained" sx={{
                      py : 9 , px : 45, width : "fit-content", borderRadius : "18px",
                      "&:hover": { color: "secondary.main" },
                    }}>Register</Button>
                </Stack>
                <Typography color="secondary" sx={{
                  fontSize : "24px",
                  fontWeight : "700",
                  textAlign : "center",
                  mt : 10,
                  mb :28
                }}>
                Issue your 1st invoice now!
                </Typography>
                <Typography color="text.secondary" sx={{
                  textAlign : "center",
                  fontSize : "22px",
                }}>
                Already have an account?
                </Typography>
                <Typography color="#00A5E4" sx={{
                  textAlign : "center",
                  fontSize : "22px",
                }}>
                  <Link to="/login">Sign in</Link>
                </Typography>
              </form>
            </Stack>
            <Stack width="fit-content" py={{xs : 16 , sm : 32}} px={{xs : 15 , sm : 30}} border="1px solid" borderColor="text" alignItems="center" borderRadius="50px">
              <div><img src={lfp2} alt="" /></div>
              <Typography sx={{
                fontWeight : "400",
                fontSize : "20px",
                mb :10,
                mt : 10
              }}>
              Register
              </Typography>
              <Stack direction="row" spacing={{xs : 2 , sm : 8}} mb={15} > 
                <Stack direction="row" alignItems="center" spacing={2}>
                  <CheckIcon color="secondary" />
                  <Typography sx={{fontSize : {xs : "14px" , sm : "16px"} , fontWeight : "400"}} >
                    Free trial 
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <CheckIcon color="secondary" />
                  <Typography sx={{fontSize : {xs : "14px" , sm : "16px"} , fontWeight : "400"}} >
                    No credit cards 
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <CheckIcon color="secondary" />
                  <Typography sx={{fontSize : {xs : "14px" , sm : "16px"} , fontWeight : "400"}} >
                    Start now 
                  </Typography>
                </Stack>
              </Stack>
              <form action="">
                <Stack spacing={12} mb={10} alignItems="center">
                  <input id="company" type="text" placeholder="Company Name" required />
                  <input id="email" type="email" placeholder="Email" required />
                  <input id="mobile" type="number" placeholder="Phone Number" required />
                  <input id="password" type="password" placeholder="Password" required /> 
                  {
                fileData?.file?.name ?
                (
                   <label id="lab" htmlFor="vat">{fileData?.file?.name}</label>
                ):
                (
                  <label id="lab" htmlFor="vat">Attach VAT Number Certificate File</label>
                )
              }
                  
                  <input required type="file" accept=".pdf,.png,.jpg,.jpeg"  onChange={handleFileInputChange} placeholder="Attach VAT Number Certificate" id="vat" name="vat" />
                
          <Typography sx={{
           fontWeight : "400",
           fontSize : {xs : "16px" , sm : "20px"},
           lineHeight : {xs : "10px" , sm : "40px"},
           textAlign : {xs : "center" , sm : "left"} 
          }}>
              Do you have an effective commercial register? 
            <label className="yes" style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeCommercialRegister"
                value="Yes"
                required 
                style={{margin:"17px 0 17px 25px"}} 

              />
              Yes
            </label>
            <label className="yes" style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeCommercialRegister"
                value="No"
                required 
                style={{margin:"17px 0 17px 35px"}} 
                
              />
              No
            </label> 
            
          </Typography>

          <Typography sx={{
           fontWeight : "400",
           fontSize : {xs : "16px" , sm : "20px"},
           lineHeight : {xs : "10px" , sm : "40px"},
           textAlign : {xs : "center" , sm : "left"} 
          }}>
              Do you have an effective tax number? 
            <label className="yes" style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeTaxNumber"
                value="Yes"
                required
                style={{margin:"17px 0 17px 25px"}} 

              />
              Yes
            </label>
            <label className="yes" style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeTaxNumber"
                value="No"
                required 
                style={{margin:"17px 0 17px 35px"}} 
                
              />
              No
            </label> 
            
          </Typography>
                </Stack>
              
                <Stack alignItems="center">
                  <Button type="submit" variant="contained" sx={{
                      py : 9 , px : 45, width : "fit-content", borderRadius : "18px",
                      "&:hover": { color: "secondary.main" },
                    }}>Register</Button>
                </Stack>
                <Typography color="secondary" sx={{
                  fontSize : "24px",
                  fontWeight : "700",
                  textAlign : "center",
                  mt : 10,
                  mb :28
                }}>
                Issue your 1st invoice now!
                </Typography>
                <Typography color="text.secondary" sx={{
                  textAlign : "center",
                  fontSize : "22px",
                }}>
                Already have an account?
                </Typography>
                <Typography color="#00A5E4" sx={{
                  textAlign : "center",
                  fontSize : "22px",
                }}>
                  <Link to="/login">Sign in</Link>
                </Typography>
              </form>
            </Stack>
          </Stack>
        </div>
        <Second />
        <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        />
        <Modal isOpen={isOpen || loading} style={customStyles}>
        {loading ? (
          <BeatLoader color="#4A90E2" />
        ) : (
                  <form onSubmit={handleOtpSubmit}>
                    <label>Please enter the confirmation code that was sent to your phone or email address</label>
                    <br />
                      <input
                          type="number"
                          value={otp}
                          onChange={e => setOtp(e.target.value)}
                          maxLength="5"
                          style={{width: "100%",height:"35px",padding:"5px 10px",margin:"10px 0",border:"1px solid #ccc",borderRadius:"5px"}}
                      />
                      <br/>
                      <button style={{width: "100%",height:"35px",background:"#4CAF50",color: "white",border: "none",borderRadius: "5px",cursor: "pointer"}} type="submit">Verify OTP</button>
                  </form>
            )}
        </Modal>
      </div>
    );
  }else{
    return (  
    <div className="Login"> 
      <div className="dFirst login sign">
      
      <img src={tr28} alt="" className="tr28" />
      <img src={tr29} alt="" className="tr29" />
      <img src={tr30} alt="" className="tr30" />
      
      <Stack direction={{xs : "column" , md : "row"}} alignItems={{xs : "center" , md : "start"}} spacing={30} justifyContent="center">
        <Stack width="fit-content" py={{xs : 16 , sm : 32}} px={{xs : 15 , sm : 30}} border="1px solid" borderColor="text" alignItems="center" borderRadius="50px">
          <div><img src={lf} alt="" /></div>
          <Typography sx={{
            fontWeight : "400",
            fontSize : "20px",
            mb :10,
            mt : 10
          }}>
          حساب جديد
          </Typography>
          <Stack direction="row" spacing={{xs : 2 , sm : 8}} mb={15} > 
            <Stack direction="row" alignItems="center" spacing={2}>
              <CheckIcon color="secondary" />
              <Typography sx={{fontSize : {xs : "14px" , sm : "16px"} , fontWeight : "400"}} >
                تجربة مجانية
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={2}>
              <CheckIcon color="secondary" />
              <Typography sx={{fontSize : {xs : "14px" , sm : "16px"} , fontWeight : "400"}} >
                لا بطاقات ائتمان
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={2}>
              <CheckIcon color="secondary" />
              <Typography sx={{fontSize : {xs : "14px" , sm : "16px"} , fontWeight : "400"}} >
                ابدأ الآن 
              </Typography>
            </Stack>
          </Stack>
          <form onSubmit={handleSubmit}>
            <Stack spacing={12} mb={10} alignItems="center">
            <input id="company1" type="text" placeholder="اسم الشركة" required />
              <input id="email1" type="email" placeholder="الايميل" required />
              <input id="mobile1" type="number" placeholder="الهاتف" required />
              <input id="password1" type="password" placeholder="كلمة المرور" required />
              {
                fileData?.file?.name ?
                (
                   <label id="lab" htmlFor="vat">{fileData?.file?.name}</label>
                ):
                (
                  <label id="lab" htmlFor="vat">إرفاق شهادة ضريبة القيمة المضافة</label>
                )
              }
              <input type="file" accept=".pdf,.png,.jpg,.jpeg"  onChange={handleFileInputChange} placeholder="Attach VAT Number Certificate" name="vat1" id="vat1" />
              <Typography sx={{
           fontWeight : "400",
           fontSize : {xs : "16px" , sm : "20px"},
           lineHeight : {xs : "10px" , sm : "40px"},
           textAlign : {xs : "center" , sm : "left"} 
          }}>
              هل تمتلك سجل تجاري فعّال؟ 
              <label className="yes" style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeCommercialRegister1"
                value="Yes"
                required
                style={{margin:"17px 5px 17px 0"}} 
              />
              نعم
            </label>
            <label className="yes" style={{ width:"75px",display: 'inline-flex'}}>
              <input
                type="radio"
                name="activeCommercialRegister1"
                value="No"
                required
                style={{margin:"17px 35px 17px 0"}} 
                
              />
              لا
            </label> 
            
          </Typography>

          <Typography sx={{
           fontWeight : "400",
           fontSize : {xs : "16px" , sm : "20px"},
           lineHeight : {xs : "10px" , sm : "40px"},
           textAlign : {xs : "center" , sm : "left"} 
          }}>
              هل لديك رقم ضريبي فعّال؟ 
            <label className="yes" style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeTaxNumber1"
                value="Yes"
                required
                style={{margin:"17px 5px 17px 0"}} 
              />
              نعم
            </label>
            <label className="yes" style={{ width:"75px",display: 'inline-flex'}}>
              <input
                type="radio"
                name="activeTaxNumber1"
                value="No"
                required
                style={{margin:"17px 35px 17px 0"}} 
                
              />
              لا
            </label> 
            
          </Typography>
            </Stack>
            
            <Stack alignItems="center">
              <Button type="submit" variant="contained" sx={{
                  py : 9 , px : 45, width : "fit-content", borderRadius : "18px",
                  "&:hover": { color: "secondary.main" },
                }}>تسجيل</Button>
            </Stack>
            <Typography color="secondary" sx={{
              fontSize : "24px",
              fontWeight : "700",
              textAlign : "center",
              mt : 10,
              mb :28
            }}>
            قم بإصدار فاتورتك الأولى الآن!
            </Typography>
            <Typography color="text.secondary" sx={{
              textAlign : "center",
              fontSize : "22px",
            }}>
            هل لديك حساب؟
            </Typography>
            <Typography color="#00A5E4" sx={{
              textAlign : "center",
              fontSize : "22px",
            }}>
              <Link id="login-a" to="/login">تسجيل الدخول</Link>
            </Typography>
          </form>
        </Stack>
        <Stack width="fit-content" py={{xs : 16 , sm : 32}} px={{xs : 15 , sm : 30}} border="1px solid" borderColor="text" alignItems="center" borderRadius="50px">
          <div><img src={lfp2} alt="" /></div>
          <Typography sx={{
            fontWeight : "400",
            fontSize : "20px",
            mb :10,
            mt : 10
          }}>
          حساب جديد
          </Typography>
          <Stack direction="row" spacing={{xs : 2 , sm : 8}} mb={15} > 
            <Stack direction="row" alignItems="center" spacing={2}>
              <CheckIcon color="secondary" />
              <Typography sx={{fontSize : {xs : "14px" , sm : "16px"} , fontWeight : "400"}} >
                تجربة مجانية
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={2}>
              <CheckIcon color="secondary" />
              <Typography sx={{fontSize : {xs : "14px" , sm : "16px"} , fontWeight : "400"}} >
                لا بطاقات ائتمان
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={2}>
              <CheckIcon color="secondary" />
              <Typography sx={{fontSize : {xs : "14px" , sm : "16px"} , fontWeight : "400"}} >
                ابدأ الآن 
              </Typography>
            </Stack>
          </Stack>
          <form onSubmit={handleSubmit}>
            <Stack spacing={12} mb={10} alignItems="center">
              <input id="company" type="text" placeholder="اسم الشركة" required />
              <input id="email" type="email" placeholder="الايميل" required />
              <input id="mobile" type="number" placeholder="الهاتف" required />
              <input id="password" type="password" placeholder="كلمة المرور" required />
              
              {
                fileData?.file?.name ?
                (
                   <label id="lab" htmlFor="vat">{fileData?.file?.name}</label>
                ):
                (
                  <label id="lab" htmlFor="vat">إرفاق شهادة ضريبة القيمة المضافة</label>
                )
              }
              
              <input type="file" accept=".pdf,.png,.jpg,.jpeg"  onChange={handleFileInputChange} placeholder="Attach VAT Number Certificate" id="vat" name="vat" />
              <Typography sx={{
           fontWeight : "400",
           fontSize : {xs : "16px" , sm : "20px"},
           lineHeight : {xs : "10px" , sm : "40px"},
           textAlign : {xs : "center" , sm : "left"} 
          }}>
              هل تمتلك سجل تجاري فعّال؟ 
              <label className="yes" style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeCommercialRegister"
                value="Yes"
                required
                style={{margin:"17px 5px 17px 0"}} 
              />
              نعم
            </label>
            <label className="yes" style={{ width:"75px",display: 'inline-flex'}}>
              <input
                type="radio"
                name="activeCommercialRegister"
                value="No"
                required
                style={{margin:"17px 35px 17px 0"}} 
                
              />
              لا
            </label> 
            
          </Typography>

          <Typography sx={{
           fontWeight : "400",
           fontSize : {xs : "16px" , sm : "20px"},
           lineHeight : {xs : "10px" , sm : "40px"},
           textAlign : {xs : "center" , sm : "left"} 
          }}>
              هل لديك رقم ضريبي فعّال؟ 
            <label className="yes" style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeTaxNumber"
                value="Yes"
                required
                style={{margin:"17px 5px 17px 0"}} 
              />
              نعم
            </label>
            <label className="yes" style={{ width:"75px",display: 'inline-flex'}}>
              <input
                type="radio"
                name="activeTaxNumber"
                value="No"
                required
                style={{margin:"17px 35px 17px 0"}} 
                
              />
              لا
            </label> 
            
          </Typography>
            </Stack>
            
            <Stack alignItems="center">
              <Button type="submit" variant="contained" sx={{
                  py : 9 , px : 45, width : "fit-content", borderRadius : "18px",
                  "&:hover": { color: "secondary.main" },
                }}>تسجيل</Button>
            </Stack>
            <Typography color="secondary" sx={{
              fontSize : "24px",
              fontWeight : "700",
              textAlign : "center",
              mt : 10,
              mb :28
            }}>
            قم بإصدار فاتورتك الأولى الآن!
            </Typography>
            <Typography color="text.secondary" sx={{
              textAlign : "center",
              fontSize : "22px",
            }}>
            هل لديك حساب؟
            </Typography>
            <Typography color="#00A5E4" sx={{
              textAlign : "center",
              fontSize : "22px",
            }}>
              <Link id="login-a" to="/login">تسجيل الدخول</Link>
            </Typography>
          </form>
        </Stack>
      </Stack>
      </div>
      <Second />
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={true}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
        />
        <Modal isOpen={isOpen || loading} style={customStyles}>
        {loading ? (
          <BeatLoader color="#4A90E2" />
        ) : (
                  <form onSubmit={handleOtpSubmit}>
                      <label>
                        الرجاء ادخال رمز التحقق المرسل الى هاتفك او بريدك الالكتروني
                      </label>
                      <br />
                      <input
                          type="number"
                          value={otp}
                          onChange={e => setOtp(e.target.value)}
                          maxLength="4"
                          style={{width: "100%",height:"35px",padding:"5px 10px",margin:"10px 0",border:"1px solid #ccc",borderRadius:"5px"}}
                      />
                      <br/>
                      <button style={{width: "100%",height:"35px",background:"#4CAF50",color: "white",border: "none",borderRadius: "5px",cursor: "pointer"}} type="submit">تأكيد الرمز</button>
                  </form>
              )}
        </Modal>
    </div>
  );
  }
}

 

export default SignUp;